import { useParams } from 'react-router-dom';
import { NotFound } from 'app/agriculture/routes/NotFound';
import { HerdEditForm } from 'app/agriculture/routes/Herds/HerdEdit/components/HerdEditForm';

export function HerdEdit() {
    const { id } = useParams();
    if (id == null) return <NotFound />;

    return <HerdEditForm herdId={id} />;
}
